<template>
  <v-simple-table v-if="workProfile">
    <tbody>
      <tr>
        <td class="font-weight-bold">{{ $t("worksProfile.orderId") }}</td>
        <td>
          {{ workProfile.id }}
        </td>
      </tr>
      <tr>
        <td class="font-weight-bold">{{ $t("worksProfile.name") }}</td>
        <td>
          {{ workProfile.name }}
        </td>
      </tr>
      <tr>
        <td class="font-weight-bold">{{ $t("worksProfile.totalCost") }}</td>
        <td>
          {{ totalCost }}
        </td>
      </tr>
      <tr>
        <td class="font-weight-bold">{{ $t("worksProfile.location") }}</td>
        <td>
          {{ workProfile.location }}
        </td>
      </tr>
      <tr>
        <td class="font-weight-bold">{{ $t("worksProfile.whoReceive") }}</td>
        <td>
          {{ workProfile.whoReceive }}
        </td>
      </tr>
      <tr>
        <td class="font-weight-bold">{{ $t("worksProfile.whoSent") }}</td>
        <td>
          {{ workProfile.whoSent }}
        </td>
      </tr>
      <tr>
        <td class="font-weight-bold">{{ $t("worksProfile.description") }}</td>
        <td>
          {{ workProfile.Description }}
        </td>
      </tr>
      <tr v-if="workProfile && workProfile.date">
        <td class="font-weight-bold">{{ $t("worksProfile.date") }}</td>
        <td>
          {{ workProfile.date | formatDate(user.language) | capitalize }}
        </td>
      </tr>
      <tr v-if="workProfile && workProfile.dueDate">
        <td class="font-weight-bold">{{ $t("worksProfile.dueDate") }}</td>
        <td>
          {{ workProfile.dueDate | formatDate(user.language) | capitalize }}
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "ListOfWorkProfile",
  computed: {
    ...mapState("auth", ["user"])
  },
  data() {
    return {
      modal: false
    };
  },
  methods: {},
  props: {
    totalCost: {},
    workProfile: {}
  }
};
</script>
